import { render, staticRenderFns } from "./EvaluationCreate.vue?vue&type=template&id=4c1ddbf3&scoped=true&"
import script from "./EvaluationCreate.vue?vue&type=script&lang=js&"
export * from "./EvaluationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ddbf3",
  null
  
)

export default component.exports